import React from "react";
import { Col, Row, Divider } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { APP_ROUTES } from "../../../constants/Routes";

const PrescriptionHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">
            {<IntlMessages id={"Addnew.prescription"} />}
          </p>
        </Col>
      </Row>

      <Divider />
    </div>
  );
};

export default PrescriptionHeader;
